import { RequestService } from '../request';

import {
  ICreateFlashcard,
  IFlashcard,
  IMoveFlashcard,
  IUpdateFlashcard,
  IGenerateFlashcardWithAI
} from './flashcard.contract';

export class FlashcardService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async createFlashCard(createFlashcard: ICreateFlashcard, collectionId: string) {
    return this.poster<IFlashcard, ICreateFlashcard>(
      `/flashcards/${collectionId}`,
      createFlashcard
    );
  }

  async generateFlashcardWithAI(
    collectionId: string,
    { flashcardCount, sections }: IGenerateFlashcardWithAI
  ) {
    return this.poster<IFlashcard[], IGenerateFlashcardWithAI>(
      `/flashcards/generate-flashcard/${collectionId}`,
      { flashcardCount, sections }
    );
  }

  async updateFlashCard(flashcard: IUpdateFlashcard) {
    return this.putter<IFlashcard, IUpdateFlashcard>(`/flashcards/${flashcard._id}`, flashcard);
  }

  async removeFlashCard(flashcardId: string, collectionId: string) {
    return this.deleter(`/flashcards/${flashcardId}/${collectionId}`);
  }

  async moveFlashcardToCollection(moveFlashcard: IMoveFlashcard, collectionId: string) {
    return this.poster<IFlashcard, IMoveFlashcard>(
      `/flashcards/move/${collectionId}`,
      moveFlashcard
    );
  }
}
